module.exports = __webpack_public_path__ + "img/ast07.4687ced3.svg";